import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Components
import { UiLoading } from '@components/ui/loading/loading';

// Services
import { HttpErrorService } from '@core/services/http-error.service';
import { Dic } from '@core/utils/dic.utils';
import { SessionService } from '@core/services/session.service';

/**
 * Composant racine — bootstrap : applique la langue et charge la session.
 * Routes : `''` → app privée (AppPage), `'home'` → landing publique CMS, `'login'` → AuthPage.
 */
@Component({
	selector: 'app-root',
	imports: [RouterOutlet, UiLoading],
	templateUrl: './app.html',
	styleUrl: './app.scss',
})
export class App {
	loading = signal(true);
	protected readonly Dic = Dic;

	constructor(
		private session: SessionService,
		public httpErrorService: HttpErrorService,
	) {
		this.session.status().subscribe(() => this.loading.set(false));
	}
}
